import React, { useContext } from "react";
import { ButtonRenderProps, ButtonProps, ContentSection, Stack, LabeledText } from "sprint-common-web";

import { EpisodePageContext } from "../context/EpisodePageProvider";
import { EditEpisodeButton } from "./buttons/EditEpisodeButton";

export const EpisodeInfo: React.FunctionComponent = () => {
    const { selectedEpisode } = useContext(EpisodePageContext);

    const editButtonProps: ButtonRenderProps<ButtonProps> = {
        render: () => EditEpisodeButton({ isLabeled: true, episodeId: selectedEpisode.id })
    };

    return (
        <ContentSection header="Info" buttons={[editButtonProps]}>
            <Stack horizontal={true} tokens={{ childrenGap: "100" }}>
                <LabeledText value={selectedEpisode.title} label="Title" />
                <LabeledText value={selectedEpisode.number} label="Episode Number" />
            </Stack>
        </ContentSection>
    );
};
